module.exports = __webpack_public_path__ + "img/h_logo_online.31abede9.png";